import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../../Common/Help/Help';
import editIcon from '../../../../images/icons/edit.svg';
import deleteIcon from '../../../../images/icons/delete.svg';
import AlertModal from '../../../Common/AlertModal/AlertModal';
import './Tags.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Tags extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            tags: [],
            form: {
                id: '',
                active: true,
                tag_name: '',
            },
            validation: {
                alreadyExists: false
            },
            editMode: false,
            isModalOpen: false,
            targetTagId: null,
            message: {
                title: '',
                content: '',
                type: ''
            }
         }
    }

    toggleAlertModal = (e) => {
        const targetTagId = e.target.id;
        this.setState({
            isModalOpen: !this.state.isModalOpen,
            targetTagId
        });
    }

    confirmAlertModal = () => {
        this.removeTag(this.state.targetTagId);
        this.setState({
            isModalOpen: false,
            targetTagId: null
        });
    }
  
    handleChange = (e) => {
        let value = e.target.value;
        const type = e.target.type;
        const form = { ...this.state.form };
        if (type === "checkbox") {
            value = e.target.checked;
            (value === false) ? value = true : value = false;
            form['active'] = value;
        } else {
            form['tag_name'] = value;
        }
        this.setState({ form }, () => this.validate());
    }

    getTags = () => {
        (async () => {
            try {
                const response = await getClientTags();
                if (response.data.error) {
                    this.props.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                } else {
                    console.log('Client Tags: ', response);
                    this.setState({ tags: response.data.tags });
                }
            } catch (error) {
                this.props.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        })()

        async function getClientTags() {
            return await ApiRequest('/tags');
        }
    }

    updateTag = () => {
        this.props.setMessage('', '', 'loading');
        const targetTagId = this.state.editMode ? this.state.targetTagId : '';
        const method = this.state.editMode ? 'put' : 'post';

        (async () => {
            try {
                let response = await addTag(this.state.form, targetTagId, method);
                if (response.data.error) {
                    this.props.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                    window.scrollTo(0, 0);
                } else {
                    console.log('Add tag Response: ', response);
                    this.props.setMessage('', '', '');
                    this.getTags();
                }
            } catch (error) {
                this.props.setMessage(window.general_strings.msg.oops, error, 'error');
                window.scrollTo(0, 0);
            }
        })()

        async function addTag(data, targetTagId, method) {
            return await ApiRequest(`/tags/${targetTagId}`, {
                method,
                data: {
                    tag_name: data.tag_name,
                    active: data.active
                }
            });
        }
        this.resetInputs();
    }

    editTag = (e) => {
        const id = parseInt(e.target.id, 0);
        const tags = [...this.state.tags];
        const tag = tags.filter(tag => tag.id === id);
        const form = { ...this.state.form };
        form['id'] = tag[0].id;
        form['active'] = tag[0].active;
        form['tag_name'] = tag[0].tag_name;
        tags.forEach((tag, i) => {
            if (tag.id === parseInt(id, 0)) {
                tags.splice(i, 1);
            }
        })
        this.setState({ 
            form,
            tags, 
            editMode: true,
            targetTagId: id
        });
    }

    removeTag = (id) => {
        const tags = [...this.state.tags];
        tags.forEach((tag, i) => {
            if (tag.id === parseInt(id, 0)) {
                tags.splice(i, 1);
            }
        })
        this.setState({ tags }, async () => {
            try {
                const response = await deleteTag();
                console.log('Delete tag: ', response);
            } catch (error) {
                console.log(error);
            }

            async function deleteTag() {
                return await ApiRequest(`/tags/${id}`, {
                    method: 'delete'
                });
            }
        })
    }

    resetInputs = () => {
        const form = {...this.state.form};
        document.getElementById('tag-inactive').checked = false;
        form['id'] = '';
        form['active'] = true;
        form['tag_name'] = '';
        this.setState({ 
            form, 
            targetTagId: null,
            editMode: false
        });
    }

    validate = () => {
        const tag_name = this.state.form.tag_name;
        const tags = [...this.state.tags];
        const validation = { ...this.state.validation }
        if (tags.some((tag) => tag.tag_name === tag_name)) {
            validation['alreadyExists'] = true;
        } else {
            validation['alreadyExists'] = false;
        }
        this.setState({ validation });
    }

    componentDidMount() {
        this.getTags();
    }

    render() { 
        return ( 
            <React.Fragment>
                <AlertModal
                    isModalOpen={this.state.isModalOpen}
                    toggleAlertModal={this.toggleAlertModal}
                    confirmAlertModal={this.confirmAlertModal}
                    modalTitle={strings.modalTitle}
                    modalDescription={strings.modalDescription}
                />
                <div className="showtix-section showtix-background__primary-2">
                    <div className="container">
                        <h1>{strings.title}</h1>

                        <div className="row">
                            <div className="col-12 col-lg-8">
                                <div className="row">
                                    <div className="col-12 col-md-4 text-left">
                                        <div className="showtix-form__group">
                                            <div className="showtix-form__checkbox">
                                                <input
                                                    id="tag-inactive"
                                                    className="showtix-input"
                                                    type="checkbox"
                                                    onChange={this.handleChange}
                                                    checked={!this.state.form.active}
                                                />
                                                <label className="showtix-label" htmlFor="tag-inactive">{strings.activeLabel}</label>
                                            </div>
                                        </div>
                                        <div className="showtix-form__group">
                                            <label className="showtix-label" htmlFor="tag-name">{strings.addTag}</label>
                                            <div className="showtix-form__input">
                                                <input
                                                    id="tag-name"
                                                    className="showtix-input"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                    value={this.state.form.tag_name}
                                                />
                                            </div>
                                            {
                                            this.state.validation.alreadyExists &&
                                                <div className="showtix-note error">
                                                    {strings.tagNameAlreadyExists}
                                                </div>
                                            }
                                        </div>
                                        <div className="showtix-form__group">
                                            <button
                                                type="button"
                                                className="showtix-button showtix-background__primary-1"
                                                onClick={this.updateTag}
                                                disabled={this.state.form.tag_name === '' || this.state.validation.alreadyExists ? true : false}
                                            >
                                                <span>{this.state.editMode ? strings.editTagButton : strings.addTagButton}</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-8 text-left">
                                        <div className="table-responsive">
                                            { this.state.tags.length > 0 ? (
                                                <table className="showtix-table showtix-table__striped showtix-table__fixed-height">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: 50 }}></th>
                                                            <th>Tag</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.tags.map((tag, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td className="text-left" style={{ width: 50 }}>
                                                                            <img
                                                                                id={tag.id}
                                                                                className="edit-icon"
                                                                                src={editIcon}
                                                                                alt="edit icon"
                                                                                onClick={this.editTag}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            {tag.tag_name} {!tag.active && <span className="showtix-badge warning" >Inactive</span>}
                                                                        </td>
                                                                        <td className="text-right">
                                                                            <img
                                                                                id={tag.id}
                                                                                className="delete-icon"
                                                                                src={deleteIcon}
                                                                                alt="delete icon"
                                                                                onClick={(e) => this.toggleAlertModal(e)}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <p>No tags yet.</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            { strings.helps &&
                            <div className="col-12 col-lg-4">
                                {strings.helps.map((help, i) =>
                                    <Help help={help} key={i} />
                                )}
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>
         )
    }
}

export default Tags;


// WEBPACK FOOTER //
// ./src/components/Client/Marketing/Tags/Tags.js